import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../Component/Breadcrumb";

export default function Newsletter() {
  return (
    <>
      <Helmet>
        <title>Newsletter - Bhadorva Infra</title>
        <meta
          name="description"
          content="At Bhadorva Infra, we bring over 15 years of expertise in real estate, specializing in luxury bungalows, premium plotting, and high-quality construction. Our commitment lies in shaping developments that reflect elegance, comfort, and timeless luxury, setting new benchmarks in modern living."
        />
        <meta
          name="keywords"
          content="Bhadorva Infra,real estate,specializing in luxury bungalows, premium plotting, high-quality construction"
        />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename="Newsletter" mainpage="" />
    </>
  );
}
